import { Card, Tabs, Table, Row, Col, Tag, Form, Input, Button, Dropdown, Menu, Upload, Progress, Modal, Skeleton, Select, Image, Space, List, Divider, InputNumber, DatePicker, Carousel } from "antd";
import "react-responsive-carousel/lib/styles/carousel.min.css";

import React, { useEffect, useState, useCallback, useRef } from "react";
// import Clock from 'react-live-clock';
import { formatCurrency } from '../common/Format'
import {
    AppstoreOutlined, SettingOutlined, DeleteOutlined, FormOutlined, CloseCircleOutlined, PlusOutlined, BgColorsOutlined,
    MenuOutlined,
} from "@ant-design/icons";
import swal from "sweetalert";

import { Editor } from '@tinymce/tinymce-react';
import 'moment/locale/vi';
import { HexColorPicker, } from "react-colorful";

import ButtonGroup from "antd/lib/button/button-group";
import moment from "moment";
import axiosClient from "../../api/axios";
import { changeUpload, updateFileListFromUrls, uploadImage, beforeUpload, getFilePreview } from '../common/Upload/upload.js'
import limitString from "../common/LimitString/litmitstring";
import LinkUpload from "../../api/LinkUpload";




const { TabPane } = Tabs;
const { Option } = Select;
const WebsiteManager = () => {
    const [progress, setProgress] = useState(0);
    const [dataArticles, setDataArticles] = useState([])
    const database = localStorage.getItem('DatabaseName');
    const token = localStorage.getItem('token');
    const IDAccount = localStorage.getItem('ID');
    const header = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
    };

    const [formBanners] = Form.useForm();
    const [formFilterBanners] = Form.useForm()
    // Quản lý banner
    const [dataBanners, setDataBanners] = useState([]);
    const [openModalBanners, setOpenModalBanners] = useState(false);
    const [loadingBanners, setLoadingBanners] = useState(false);
    const [statusBanners, setStatusBanners] = useState(false);


    // upload image
    const [fileListBanners, setFileListBanners] = useState([]);



    const changeUploadBanners = async ({ fileList }) => {
        const dataImage = fileList.map(r => `/Uploads/${database}/` + database + '/' + r.name);
        setFileListBanners(fileList);
        const resultURL = dataImage.join(";");
        formBanners.setFieldsValue({
            ImageURL: resultURL,
        })
    };




    // const uploadImage = async options => {
    //     const { onSuccess, onError, file, onProgress } = options;
    //     const fmData = new FormData();
    //     const config = {
    //         headers: {
    //             "content-type": "multipart/form-data",
    //             Accept: "application/json",
    //             Authorization: `Bearer ${token}`,
    //         },
    //         onUploadProgress: event => {
    //             const percent = Math.floor((event.loaded / event.total) * 100);
    //             setProgress(percent);
    //             if (percent === 100) {
    //                 setTimeout(() => setProgress(0), 1000);
    //             }
    //             onProgress({ percent: (event.loaded / event.total) * 100 });
    //         }
    //     };

    //     const filenew = new File([file], file.name, {
    //         type: 'image/png'
    //     });
    //     fmData.append("image", filenew);
    //     try {

    //         const res = await axiosClient.post(
    //             `/uploadfile?subDirectory=${database}`,
    //             fmData,
    //             config
    //         );
    //         onSuccess("Ok");
    //         console.log("server res: ", res);
    //         if (res.status === 200) {
    //             setProgress(0)
    //         }

    //     } catch (err) {
    //         console.log("Eroor: ", err);
    //         const error = new Error("Some error");
    //         onError({ err });
    //     }

    // };

    const showModalBanners = (record) => {
        //const IDTemp = 0;
        setFileListBanners([])
        formBanners.resetFields();
        if (typeof record === 'object') {
            setLoadingBanners(false)
            setStatusBanners(true)
            updateFileListFromUrls(setFileListBanners, record.ImageURL)
            formBanners.setFieldsValue(
                {
                    "ID": record.ID,
                    "Title": record.Title,
                    "ImageURL": record.ImageURL,
                    "LinkURL": record.LinkURL,
                    "Position": record.Position,
                    "StartDate": moment(record.StartDate),
                    "EndDate": moment(record.EndDate),
                    "Status": record.Status,
                    "CreateDate": moment(record.CreateDate),
                    "UpdateDate": moment()
                }
            );
            setOpenModalBanners(true)
        }
        else {
            setLoadingBanners(false)
            setStatusBanners(false)
            formBanners.setFieldsValue({
                "ID": 1,
                "Title": "",
                "ImageURL": "",
                "LinkURL": "",
                "Position": "",
                "StartDate": "",
                "EndDate": "",
                "Status": true,
                "CreateDate": moment(),
                "UpdateDate": ""

            })
            setOpenModalBanners(true)
        }


    }
    const base64ToBlob = (base64, contentType = '') => {
        const byteCharacters = atob(base64);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 512) {
            const slice = byteCharacters.slice(offset, offset + 512);
            const byteNumbers = Array.from(slice).map(char => char.charCodeAt(0));
            byteArrays.push(new Uint8Array(byteNumbers));
        }

        return new Blob(byteArrays, { type: contentType });
    };
    function blobToFileListItem(blob, fileName) {
        const fileUrl = URL.createObjectURL(blob); // Tạo URL tạm thời từ Blob
        return {
            uid: Date.now().toString(),  // Tạo một UID duy nhất
            name: fileName || "file",   // Tên file
            status: "done",             // Đặt trạng thái 'done' vì file đã sẵn sàng
            url: fileUrl,               // Gắn URL để xem trước
            originFileObj: blob         // Blob gốc để tải lên
        };
    }

    const fillArrayBanner = (arr) => {
        const list = [];
        arr.map(r => {
            const fileName = String(r).split('/files/')[1]
            axiosClient.get(`/ReadFile?fileName=${fileName}`, { headers: header }).then(resRead => {
                const file = blobToFileListItem(base64ToBlob(resRead.data.base64Content, resRead.data.contentType), fileName);
                list.push(file)
                if (list[0].name === '') {
                    setFileListBanners([])
                }
                else {
                    setFileListBanners(list)
                }
            })
        })
    }

    const onFinishBanners = (values) => {

        setLoadingBanners(true)
        if (statusBanners === false) {
            axiosClient.post('/Banners/AddBanners', values, {
                headers: header
            }).then(res => {
                setLoadingBanners(false)
                swal('Thành công!', {
                    icon: 'success'
                })
                formBanners.resetFields();
                LoadDataBanners();
                setOpenModalBanners(false)
            })
        }
        else {

            axiosClient.post('/Banners/UpdateBanners', values, {
                headers: header
            }).then(res => {
                if (res.status === 200) {

                    setLoadingBanners(false)
                    swal('Thành công!', {
                        icon: 'success'
                    })
                    formBanners.resetFields();
                    LoadDataBanners();
                    setOpenModalBanners(false)
                }
            })
        }

    }

    const LoadDataBanners = () => {
        axiosClient.post('/Banners/GetBannersAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataBanners(res.data);
            }
        })
    }


    const [dataPermission, setDataPermission] = useState([]);
    const LoadDataPermission = () => {
        axiosClient.post('/Permissions/GetApiPermissionAll', '', { headers: header }).then(resPermiss => {
            setDataPermission(resPermiss.data);
        })
    }

    // const beforeUpload = (file) => {
    //     // Tạo file mới với tên mới
    //     const newFile = new File([file], moment().toDate().valueOf() + `${file.name}`, { type: file.type });
    //     return newFile;
    // };
    const [statusSelect, setStatusSelect] = useState(false)
    const handleSelectArticle = (value) => {
        if (value === 0) {
            setStatusSelect(false)
        }
        else {
            setStatusSelect(true)
            formBanners.setFieldsValue({
                LinkURL: '/view/' + dataArticles.find(i => i.ID === value).Slug
            })
        }

    }

    const renderBanners = () => {
        return (
            <Form
                id="form-Banners"
                form={formBanners}
                onFinish={onFinishBanners}
                colon={false}
                name="basic"
                labelCol={{
                    span: 6,
                }}
                wrapperCol={{
                    span: 18,
                }}
                initialValues={{
                    remember: true,
                }}
                autoComplete="off"
            >
                <Form.Item hidden name='ID'>
                    <Input />
                </Form.Item>
                <Form.Item hidden name='CreateDate'>
                    <Input />
                </Form.Item>
                <Form.Item hidden name='UpdateDate'>
                    <Input />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: true,
                        message: 'Nhập nội dung',
                    },
                ]} name='Title' label='Nội dung'>
                    <Input.TextArea />
                </Form.Item>
                <Form.Item name={'IDArticle'} label='Bài viết'>
                    <Select onSelect={handleSelectArticle} showSearch optionFilterProp="children"
                        filterOption={(input, option) =>
                            option?.children.toLowerCase().includes(input.toLowerCase())
                        }>
                        <Option value={0}>Chọn link bên ngoài</Option>
                        {dataArticles.map(r => (
                            <Option value={r.ID}>{r.Title}</Option>
                        ))}
                    </Select>
                </Form.Item>
                <Form.Item name='LinkURL' label='Đường dẫn'>
                    <Input disabled={statusSelect} />
                </Form.Item>
                <Form.Item hidden rules={[
                    {
                        required: false,
                        message: 'Chọn vị trí hiển thị',
                    },
                ]} name='Position' label='Vị trí'>
                    <Select>
                        <Option value='header1'>Header 1</Option>
                        <Option value='header2left'>Header 2 trái</Option>
                        <Option value='header2right'>Header 2 phải</Option>
                        <Option value='bannerQC'>Banner quảng cáo</Option>
                        <Option value='bannerQCphai1'>Banner quảng cáo phải 1</Option>
                        <Option value='bannerQCphai2'>Banner quảng cáo phải 2</Option>
                        <Option value='bannerQCphai3'>Banner quảng cáo phải 3</Option>
                        <Option value='bannerQCphai4'>Banner quảng cáo phải 4</Option>
                        <Option value='header3'>Header 3</Option>
                    </Select>
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: false,
                        message: 'Chọn ngày bắt đầu',
                    },
                ]} name='StartDate' label='Ngày bắt đầu'>
                    <DatePicker style={{ width: '100%' }} format={'DD-MM-YYYY'} />
                </Form.Item>
                <Form.Item rules={[
                    {
                        required: false,
                        message: 'Chọn ngày kết thúc',
                    },
                ]} name='EndDate' label='Ngày kết thúc'>
                    <DatePicker style={{ width: '100%' }} format={'DD-MM-YYYY'} />
                </Form.Item>
                <Form.Item name='Status' label='Trạng thái'>
                    <Select>
                        <Option value={true}>Hiển thị</Option>
                        <Option value={false}>Không hiển thị</Option>
                    </Select>
                </Form.Item>



                <Form.Item name={'ImageURL'} label='Hình ảnh'>
                    <Upload
                        multiple
                        listType="picture-card"
                        customRequest={uploadImage}
                        beforeUpload={beforeUpload}
                        maxCount={1}
                        fileList={fileListBanners}
                        onPreview={(file) => window.open(file.url)}
                        onChange={(info) => changeUpload(formBanners, 'ImageURL', info, setFileListBanners)}
                        onRemove={(file) => {
                            // Xử lý khi file bị xóa
                            // Ví dụ: Cập nhật lại fileLists sau khi file bị xóa
                            const updatedFileList = fileListBanners.filter(f => f.uid !== file.uid);  // Loại bỏ file bị xóa
                            setFileListBanners(updatedFileList);  // Cập nhật lại danh sách file
                        }}
                    >
                        <Button
                            style={{
                                width: "100%",
                                height: 100,
                                border: "2px dashed #40a9ff",
                                backgroundColor: "#f0faff",
                                borderRadius: 8,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 5,
                                color: "#1890ff",
                                fontWeight: 500,
                            }}
                        >
                            <PlusOutlined style={{ fontSize: 24 }} />
                            <span>Upload Ảnh</span>
                        </Button>
                    </Upload>
                </Form.Item>
            </Form >
        )
    }
    // const onDeleteBanners = (id) => {
    //     axiosClient.post('/Banners/DeleteBanners/' + id, '', { headers: header })
    // }

    const columnBanners = [
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 10 }}>
                    Nội dung
                </div>
            ),
            dataIndex: 'Name',
            width: 200,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 11 }}>
                        <Row>
                            <Col span={24}>
                                {record.Title}
                            </Col>
                            <Col span={24}>
                                Ngày bắt đầu: <b>{moment(record.StartDate).format('DD-MM-YYYY') || ''}</b>
                            </Col>
                            <Col span={24}>
                                Ngày kết thúc: <b>{moment(record.EndDate).format('DD-MM-YYYY') || ''}</b>
                            </Col>
                        </Row>

                    </div>
                );
            },
        },

        {
            title: (
                <div style={{ textAlign: "center", fontSize: 10 }}>
                    Đường dẫn
                </div>
            ),
            dataIndex: 'Zalo',
            width: 150,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "left", fontSize: 11 }}>
                        {record.Url}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 10 }}>
                    Ngày tạo
                </div>
            ),
            dataIndex: 'Zalo',
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center", fontSize: 11 }}>
                        {moment(record.CreateDate).format('DD-MM-YYYY') || ''}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 10 }}>
                    Ngày sửa
                </div>
            ),
            dataIndex: 'Zalo',
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center", fontSize: 11 }}>
                        {moment(record.UpdateDate).format('DD-MM-YYYY') || ''}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 10 }}>
                    Vị trí
                </div>
            ),
            dataIndex: 'Zalo',
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center", fontSize: 11 }}>
                        {record.Position === 'header1' ? 'Header 1' : null}
                        {record.Position === 'header2left' ? 'Header 2 trái' : null}
                        {record.Position === 'header2right' ? 'Header 2 phải' : null}
                        {record.Position === 'bannerQC' ? 'Banner quảng cáo' : null}
                        {record.Position === 'bannerQCphai1' ? 'Banner quảng cáo phải 1' : null}
                        {record.Position === 'bannerQCphai2' ? 'Banner quảng cáo phải 2' : null}
                        {record.Position === 'bannerQCphai3' ? 'Banner quảng cáo phải 3' : null}
                        {record.Position === 'bannerQCphai4' ? 'Banner quảng cáo phải 4' : null}
                        {record.Position === 'header3' ? 'Header 3' : null}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 10 }}>
                    Trạng thái
                </div>
            ),
            dataIndex: 'Zalo',
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center", fontSize: 11 }}>
                        {record.Status === true ? <Tag color="#108ee9">Hiển thị</Tag> : <Tag color="#f50">Ẩn</Tag>}
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 10 }}>
                    Hình ảnh
                </div>
            ),
            dataIndex: 'Logo',
            width: 100,
            render: (text, record) => {
                const arrImage = String(record.ImageURL).split(';');
                return (
                    <div style={{ textAlign: "center", fontSize: 11 }}>

                        <Image.PreviewGroup>
                            <Carousel infinite={false} autoplay>
                                {arrImage.filter(Boolean).map(r => (
                                    <Image style={{ width: 40 }} src={LinkUpload(r)} />
                                ))}
                            </Carousel>
                        </Image.PreviewGroup>
                    </div>
                );
            },
        },
        {
            title: (
                <div style={{ textAlign: "center", fontSize: 10 }}>
                    <SettingOutlined />
                </div>
            ),
            width: 100,
            render: (text, record) => {
                return (
                    <div style={{ textAlign: "center", fontSize: 11 }}>
                        <ButtonGroup>
                            <Button disabled={dataPermission.includes('UpdateBanners') ? false : true} icon={<FormOutlined style={{ color: "#33CCFF" }} />} onClick={(e) => showModalBanners(record)}  ></Button>
                            {/* &ensp;
                            <Button
                                disabled={dataPermission.includes('DeleteBanners') ? false : true}
                                onClick={(e) => {
                                    onDeleteBanners(record.ID, e);
                                }}
                                icon={<DeleteOutlined style={{ color: "red" }} />}
                            ></Button> */}
                        </ButtonGroup>
                    </div>
                );
            },
        },
    ]
    const LoadDataArticles = () => {
        axiosClient.post('/Articles/GetArticlesAll', '', {
            headers: header
        }).then(res => {
            if (res.status === 200) {
                setDataArticles(res.data);
            }
        })
    }

    useEffect(() => {
        LoadDataArticles()
        LoadDataPermission()
        LoadDataBanners();

    }, [])


    const handleCancelBanners = () => {
        setLoadingBanners(false);
        setOpenModalBanners(false);
    }
    const handleOkBanners = () => {
        setTimeout(() => {
            setLoadingBanners(false);
            setOpenModalBanners(false);
        }, 3000);
    }


    return (
        <div>
            <Card size="small">
                <Tabs type="card"
                    tabBarGutter={10}
                    tabPosition="top" // Hiển thị tabs theo chiều ngang
                    tabBarStyle={{ backgroundColor: "#D6E4FF", borderRadius: "8px", boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)" }}
                    moreIcon={null} >

                    <TabPane tab="Banner" key="1">
                        <Row gutter={16}>
                            <Col span={24}>
                                <Form id="form-filter-Banners" form={formFilterBanners}>
                                    {/* <Row gutter={[8, 8]}>
                                        <Col xs={24} xl={24} span={4}>
                                            <Button hidden={dataPermission.includes('AddBanners') ? false : true} key={1} onClick={(e) => showModalBanners(0, e)} style={{ backgroundColor: '#00CC99', color: 'white', minWidth: 100, borderRadius: 5 }} icon={<PlusOutlined style={{ color: 'white' }} />}>
                                                Thêm mới
                                            </Button>
                                        </Col>
                                    </Row> */}
                                </Form>
                            </Col>
                            <Col span={24}>
                                <br />
                            </Col>
                            <Col xs={24} xl={24} span={24}>
                                <Table rowClassName={(record, index) => {
                                    return index % 2 === 0 ? "gray-color" : "";
                                }} scroll={{ x: 1000 }} size="middle" dataSource={dataBanners} pagination={{ pageSize: 10 }} sticky columns={columnBanners} />
                            </Col>
                        </Row>
                    </TabPane>

                </Tabs>
            </Card>

            <Modal
                width={600}
                onOk={handleOkBanners}
                onCancel={handleCancelBanners}
                open={openModalBanners}
                title={
                    <span>
                        {statusBanners === false ? 'Thêm mới ảnh bìa' : 'Cập nhật ảnh bìa'}
                    </span>
                }
                footer={[
                    <Button onClick={handleCancelBanners} key="back" >
                        Hủy
                    </Button>,
                    <Button form="form-Banners" type="primary" htmlType="submit" loading={loadingBanners}>
                        Lưu
                    </Button>,
                ]}
            >
                {loadingBanners ? (
                    <>
                        <Skeleton loading={loadingBanners} active />
                    </>
                ) : (
                    <>{renderBanners()}</>
                )}
            </Modal>


        </div >
    )

}
export default WebsiteManager;